import React from "react";

interface Props {
  onStartChange: (date: string) => void;
  onEndChange: (date: string) => void;
  startDate?: string;
  endDate?: string;
  className?: string;
  required?: boolean;
}

export default function DateRangePicker({
  onStartChange,
  onEndChange,
  startDate,
  endDate,
  className = "",
  required = false,
}: Props) {
  const formatDate = (date: Date): string => date.toISOString().split("T")[0];

  const handleStartChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newDate = e.target.value;

    onStartChange(newDate);
  };

  const handleEndChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newDate = e.target.value;

    onEndChange(newDate);
  };

  return (
    <div className={`flex items-center  ${className}`}>
      <div className="flex flex-col">
        <input
          type="date"
          value={startDate}
          onChange={handleStartChange}
          max={endDate}
          required={required}
          className="border px-1  rounded"
        />
      </div>
      <div className="w-2 h-0 border"></div>
      <div className="flex flex-col">
        <input
          type="date"
          value={endDate}
          onChange={handleEndChange}
          required={required}
          min={startDate}
          className="border px-1  rounded"
        />
      </div>
    </div>
  );
}
